import { BasicCarousel } from '@/atomic-components/carousels/wrappers/basic-carousel';
import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import React from 'react';

export interface IStorytellingDataProps {
	storytelling: StorytellingData;
}

interface StorytellingData {
	label: string;
	subtitle: string;
	images: Images[];
	desktopImages: Images[];
}

export interface Images {
	aspectRatio: number;
	deviceType?: string;
	rank?: number;
	type?: string;
	url: string;
}

const StorytellingDataComponent = (props: IStorytellingDataProps) => {
	return (
		<FlexBox direction='column'>
			<LencoTypography
				sx={{ ...getStyle('H6_Medium'), color: getColor('Gray 0') }}
			>
				{props?.storytelling?.label}
			</LencoTypography>
			<LencoTypography
				sx={{
					...getStyle('H14_Regular'),
					color: getColor('Gray -2'),
					paddingBottom: '24px',
				}}
			>
				{props?.storytelling?.subtitle}
			</LencoTypography>
			{props?.storytelling && (
				<BasicCarousel
					spaceBetween={10}
					slidesPerView={3}
					dots={true}
					isLeftAligned={true}
				>
					{props?.storytelling?.desktopImages?.map((img, index) => {
						return (
							<Box sx={{ width: '393px', height: '208px' }} key={img?.url}>
								<LencoImage url={img?.url} aspectRatio={img?.aspectRatio} />
							</Box>
						);
					})}
				</BasicCarousel>
			)}
		</FlexBox>
	);
};

export default StorytellingDataComponent;
